import { useI18n, useSignal } from '@funtech-int/rival-react';

export function useLocale() {
    return useSignal(useI18n().locale);
}
